/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const ArrowRight: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M22.707 11.2929L15 3.58594L13.586 4.99994L19.586 10.9999H2C1.447 10.9999 1 11.4479 1 11.9999C1 12.5519 1.447 12.9999 2 12.9999H19.586L13.586 18.9999L15 20.4139L22.707 12.7069C23.098 12.3159 23.098 11.6839 22.707 11.2929Z'
      fill='currentColor'
    />
  </React.Fragment>
)
